export default __webpack_public_path__ + "static/media/dora-dialyzer2.5e402dae.JPG";